import React from "react";
import StatusChip from "../../components/StatusChip.jsx";
import PopupDone, { usePopupDone } from "../../../../components/common/PopupDone/PopupDone.jsx";

const DASH = "—";

const dayLabel = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : DASH;

/* One trainer leave, read in full. Same vocabulary as the override popup
   beside it and as the trainer record popup on the Trainers tab, so all
   three are the same dialog with different facts in it.

   The span is stated as well as its two ends: "how long is this trainer
   away" is the question a reader brings to this list, and it is the one
   thing two dates side by side never answer on their own. */
const LeaveRecordModal = ({ record, status, canEdit, onClose, onEnd }) => {
  // Open while it has a record; the hook runs before the early return. Ending
  // or removing the leave from here shows the done panel in place of the
  // record, and the popup closes itself after five seconds.
  const { done } = usePopupDone(Boolean(record));

  if (!record) return null;

  const from = record.fromDate ? new Date(record.fromDate) : null;
  const to = record.toDate ? new Date(record.toDate) : null;
  const days =
    from && to && !Number.isNaN(from.getTime()) && !Number.isNaN(to.getTime())
      ? Math.max(
          1,
          Math.round((to.setHours(0, 0, 0, 0) - from.setHours(0, 0, 0, 0)) / 86400000) + 1,
        )
      : null;

  const past = status?.key === "past";

  return (
    <div
      className="pg-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pgm-leave-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="pg-modal-panel pg-modal-panel--wide">
        <header className="pgm-head">
          <div className="pgm-head-main">
            <h2 className="pgm-batch" id="pgm-leave-title">
              {record.trainerName || DASH}
            </h2>
            <dl className="pgm-ident">
              <div className="pgm-ident-row">
                <dt>Status</dt>
                <dd>
                  <StatusChip status={status?.key === "absent" ? "absent" : ""}>
                    {status?.label || DASH}
                  </StatusChip>
                </dd>
              </div>
              <div className="pgm-ident-row">
                <dt>From</dt>
                <dd>{dayLabel(record.fromDate)}</dd>
              </div>
              <div className="pgm-ident-row">
                <dt>To</dt>
                <dd>{dayLabel(record.toDate)}</dd>
              </div>
              <div className="pgm-ident-row">
                <dt>Length</dt>
                <dd>{days ? `${days} day${days === 1 ? "" : "s"}` : DASH}</dd>
              </div>
            </dl>
          </div>

          <button
            type="button"
            className="pg-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </header>

        <div className="pg-modal-body">
          {done ? (
            <PopupDone message={done} onClose={onClose} />
          ) : (
            <>
              <section className="pgm-section">
                <h3 className="pgm-section-title">Reason</h3>
                {record.reason ? (
                  <p className="lp-plain">{record.reason}</p>
                ) : (
                  <p className="pgm-empty">No reason was recorded.</p>
                )}
              </section>

              <section className="pgm-section">
                <h3 className="pgm-section-title">Note</h3>
                {record.note ? (
                  <p className="lp-plain">{record.note}</p>
                ) : (
                  <p className="pgm-empty">Nothing was added.</p>
                )}
              </section>
            </>
          )}
        </div>

        {!done && (
          <footer className="pg-modal-foot">
            <div className="pgm-actions">
              {canEdit && (
                <button
                  type="button"
                  className="pgm-btn pgm-btn--danger"
                  onClick={() => onEnd(record)}
                >
                  {past ? "Remove leave" : "End leave"}
                </button>
              )}
            </div>
            <button type="button" className="pg-btn pg-btn--main" onClick={onClose}>
              Close
            </button>
          </footer>
        )}
      </div>
    </div>
  );
};

export default LeaveRecordModal;
